// components/SuperAdminGuard.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const SuperAdminGuard = ({ children }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const superToken = Cookies.get('superAdminToken');
    const authToken = Cookies.get('authToken');
    
    // If authToken exists but not superToken, this is a regular admin
    if (authToken && !superToken) {
      navigate('/home');
      return;
    }
    
    // If no super token, go to login
    if (!superToken) {
      navigate('/login');
      return;
    }
    
    // If we have super token, stay here
  }, [navigate]);
  
  return <>{children}</>;
};

export default SuperAdminGuard;